export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';
export const AUTH = 'tzo_auth';
export const RESPONSEMESSAGE = 'tzo_responseMessage';
export const SUCCESS = 'Success';
export const FAILURE = 'Failure';
export const MFA_TOKEN = 'mfa_token';
export const TOKEN = 'tzo_token';
export const REFRESHTOKEN = 'tzo_refreshtoken';
